import profile from '../../services/profile'
import ls from '../../services/ls'
const state = ()=>({
  Userprofile: {
    
  }
})
const getters = {
  profile_data: state => state.Userprofile,
}

// actions
const actions = {
  fetchProfile({commit}){
    return new Promise((resolve, reject) => {
        profile.get()
      .then(resp => {
        const user_profile = resp.data.profile
        ls.set('_u_p_im',  resp.data.profile.image)
        commit('fetch_user_profile', user_profile)
        resolve(resp)
      })
      .catch(err => {
        commit('user_error')
        reject(err)
      })
    })
},
update({commit},updated_profiile){
  // console.log(updated_profiile);
  profile.post(updated_profiile);
  commit('fetch_user_profile', updated_profiile)
}
}

// mutations
const mutations = {
  fetch_user_profile(state, user){
    state.Userprofile=user
    
},
user_error(state){
  state.Userprofile=''
}
}

export default{
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
